/**
 * Floating modal Vue Component
 * ------------------------------------------------------------------------------
 * Main template in sections/index__floating-modal.liquid
 */

export default {

  data () {
    return {
      isModalShown: false
    }
  },

  methods: {
    toggleModal () {
      this.isModalShown = !this.isModalShown
    }
  }

}
